import React, { useState, useRef, useContext, useEffect, useCallback } from 'react'
import {startViewer, stopViewer} from '../components/viewer'
import {startMaster, stopMaster} from '../components/master'
import useAuth from '../hooks/useAuth'
import { SocketContext } from '../contexts/socketContext'

const Room = ({ room }) => {
  const { socket } = useContext(SocketContext)
  const { awsAccessKeyId, awsSecretAccessKey, awsSessionToken, user } = useAuth()


  useEffect(() => {
    socket.emit('join-room', room._id, {userId: user.id, channelARN: user.channelARN, streamType: 'CAMERA'})
    return () => {
      socket.emit('leave-room', room._id, {userId:user.id})
    }
  }, [room._id, socket, user.channelARN, user.id])
  // Get params for kvs webrtc video stream
  const getFormValues = useCallback((channelARN, isMaster) =>{
    return {
        region: 'ap-southeast-2',
        channelARN: channelARN,
        clientId: 'clienttest',
        sendVideo: isMaster,
        sendAudio: isMaster,
        openDataChannel: true,
        widescreen: true,
        fullscreen: false,
        useTrickleICE: true,
        natTraversalDisabled: false,
        forceTURN: false,
        accessKeyId: awsAccessKeyId,
        // endpoint: '',
        secretAccessKey: awsSecretAccessKey,
        sessionToken: awsSessionToken,
    };
  }, [awsAccessKeyId, awsSecretAccessKey, awsSessionToken])

  return (
    <div>
      Room: {JSON.stringify(room.streams.map(stream => stream?.users_permissions_user?.username), null, 2)}
      <div>
        {/* Users stream */}
        {room.streams.filter(s => s.users_permissions_user._id === user.id).map(s => 
          <MasterStream key={s._id} formValues={getFormValues(s.channelARN, true)} />
        )}
      </div>
      <div>
        {/* Users stream */}
        {room.streams.filter(s => s.users_permissions_user._id !== user.id).map(s => 
          <ViewerStream key={s._id} formValues={getFormValues(s.channelARN, false)} />
        )}
      </div>

      {/* {(!view) &&
        <div>
          <button onClick={() => { setView('MASTER') }}>Master</button>
          <button onClick={() => { setView('VIEWER') }}>Viewer</button>
        </div>
      } */}
      {/* {(view === 'MASTER') &&
        <MasterStream getFormValues={getFormValues} />
      }
      {(view === 'VIEWER') &&
        <ViewerStream getFormValues={getFormValues} />
      } */}
    </div>
  )
}

export default Room

const MasterStream = ({formValues}) => {

  const remoteView = useRef(null)
  const localView = useRef(null)

  const [renders, setRenders] = useState(0)
  const kvsConfig = useRef(formValues)
  useEffect(() => {
    if (kvsConfig.current) {
      setRenders(prev => prev+1)
      console.log("starting master", kvsConfig.current)
      startMaster(localView.current, remoteView.current, kvsConfig.current, (e) => console.log(e), (e) => console.log(e))
    }
    return () => {
      stopMaster()
    }
  }, [])

  // const onStartMaster = () => {
  //   startMaster(localView.current, remoteView.current, formValues, (e) => console.log(e), (e) => console.log(e))
  // }

  return (   <div id="master" className="d-none">
  <h2>Master</h2>
  <h2>renders: {renders}</h2>
  <div className="row">
      <div className="col">
          <h5>Master Section</h5>
          <div className="video-container"><video ref={localView} className="local-view" autoPlay playsInline controls muted /></div>
      </div>
      {/* <div className="col">
          <h5>Viewer Return Channel</h5>
          <div className="video-container"><video ref={remoteView} className="remote-view" autoPlay playsInline controls /></div>
      </div> */}
  </div>
  {/* <div className="row datachannel">
      <div className="col">
          <div className="form-group">
            <textarea type="text" className="form-control local-message" placeholder="DataChannel Message"> </textarea>
          </div>
      </div>
      <div className="col">
          <div className="card bg-light mb-3">
              <pre className="remote-message card-body text-monospace preserve-whitespace"></pre>
          </div>
      </div>
  </div>
  <div>
      <span className="send-message datachannel">
        <button type="button" className="btn btn-primary">Send DataChannel Message</button>
      </span>
      <button id="stop-master-button" type="button" className="btn btn-primary">Stop Master</button>
      <button onClick={onStartMaster} id="start-master-button" type="button" className="btn btn-primary">Start Master</button>
  </div> */}
</div>)
}


const ViewerStream = ({formValues}) => {
  const remoteView = useRef(null)
  const localView = useRef(null)
  const [renders, setRenders] = useState(0)

  // const onStartViewer= () => {
  //   startViewer(localView.current, remoteView.current, formValues, (e) => console.log(e), (e) => console.log(e))
  // }

  const kvsConfig = useRef(formValues)
  useEffect(() => {
    if (kvsConfig.current) {
      setRenders(prev => prev+1)
      console.log("starting viewer", kvsConfig.current)
      startViewer(localView.current, remoteView.current, kvsConfig.current, (e) => console.log(e), (e) => console.log(e))
    }
    return () => {
      stopViewer()
    }
  }, [])
  return (
    <div id="viewer" className="d-none">
          <h2>Viewer</h2>
          <h2>renders: {renders}</h2>
          <div className="row">
              {/* <div className="col">
                  <h5>Return Channel</h5>
                  <div className="video-container"><video ref={localView} className="local-view" autoPlay playsInline controls muted /></div>
              </div> */}
              <div className="col">
                  <h5>From Master</h5>
                  <div className="video-container"><video ref={remoteView} className="remote-view" autoPlay playsInline controls /></div>
              </div>
          </div>
          {/* <div className="row datachannel">
              <div className="col">
                  <div className="form-group">
                    <textarea type="text" className="form-control local-message" placeholder="DataChannel Message"> </textarea>
                  </div>
              </div>
              <div className="col">
                  <div className="card bg-light mb-3">
                      <pre className="remote-message card-body text-monospace preserve-whitespace"></pre>
                  </div>
              </div>
          </div>
          <div>
              <span className="send-message datachannel d-none">
                <button type="button" className="btn btn-primary">Send DataChannel Message</button>
              </span>
              <button id="stop-viewer-button" type="button" className="btn btn-primary">Stop Viewer</button>
              <button onClick={onStartViewer} id="start-viewer-button" type="button" className="btn btn-primary">Start Viewer</button>
          </div> */}
      </div>
  )
}